// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"448":"4a16805e957ad1c4","584":"24eeff2db7d4d509"}[chunkId] + ".js";
};